import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse
} from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class GlobalErrorInterceptor implements HttpInterceptor {
  constructor(private router: Router) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Skip API calls from global error handling
    if (req.url.startsWith(environment.apiUrl)) {
      return next.handle(req);
    }

    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        // Prevent redirect loops if the current route is already under /error
        if (this.router.url.startsWith('/error')) {
          return throwError(() => error);
        }
        if (error) {
          const status = error.status;
          if (status === 0) {
            console.error('Network error:', error);
            return throwError(() => error);
          }
          switch (status) {
            case 400:
              this.router.navigate(['/error/400'], { replaceUrl: true });
              break;
            case 401:
              this.router.navigate(['/error/401'], { replaceUrl: true });
              break;
            case 403:
              this.router.navigate(['/error/403'], { replaceUrl: true });
              break;
            case 404:
              this.router.navigate(['/error/404-2'], { replaceUrl: true });
              break;
            case 503:
              this.router.navigate(['/error/503'], { replaceUrl: true });
              break;
            case 504:
              this.router.navigate(['/error/504'], { replaceUrl: true });
              break;
            case 500:
            default:
             // this.router.navigate(['/error/500']);
              break;
          }
        }
        return throwError(() => error);
      })
    );
  }
}
